class ProductDetailCarousel extends HTMLElement {
  connectedCallback() {
    this.#init();
  }

  disconnectedCallback() {
    this.swiper?.destroy?.(true, true);
  }

  #init(attempt = 0) {
    const container = this.querySelector('.swiper');
    if (!container) return;

    if (!window.Swiper) {
      if (attempt > 100) return; // ~5s safety cap
      setTimeout(() => this.#init(attempt + 1), 50);
      return;
    }

    this.swiper = new window.Swiper(container, {
      slidesPerView: 1.18,
      spaceBetween: 8,
      grabCursor: true,
      // mousewheel: {
      //   releaseOnEdges: true,
      // },
      mousewheel: {
        forceToAxis: true, // Prevents trackpad from scrolling the page vertically
        sensitivity: 1,    // Adjusts scroll sensitivity
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true, // Optional: Only control slider when it is visible
      },
      breakpoints: {
        750: { slidesPerView: 'auto',
          spaceBetween: 32,
        },
      },
    });
  }
}

if (!customElements.get('product-detail-carousel')) {
  customElements.define('product-detail-carousel', ProductDetailCarousel);
}
